var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolanaCli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 195,
    viewBox: "0 0 248 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 195,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9947 114.847C62.4775 114.354 63.1413 114.067 63.8454 114.067H127.693C128.859 114.067 129.443 115.504 128.618 116.346L116.005 129.22C115.523 129.713 114.859 130 114.155 130H50.3075C49.1408 130 48.5575 128.563 49.3822 127.721L61.9947 114.847Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9947 66.7802C62.4976 66.2875 63.1615 66 63.8454 66H127.693C128.859 66 129.443 67.4373 128.618 68.2791L116.005 81.153C115.523 81.6458 114.859 81.9333 114.155 81.9333H50.3075C49.1408 81.9333 48.5575 80.496 49.3822 79.6542L61.9947 66.7802Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.005 90.6596C115.523 90.1668 114.859 89.8794 114.155 89.8794H50.3075C49.1408 89.8794 48.5575 91.3166 49.3822 92.1585L61.9947 105.032C62.4775 105.525 63.1413 105.813 63.8454 105.813H127.693C128.859 105.813 129.443 104.375 128.618 103.534L116.005 90.6596Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.4 109.4V105.92L164.8 99.84C165.307 99.6 165.773 99.4 166.2 99.24C166.653 99.0533 166.987 98.9333 167.2 98.88C166.96 98.8267 166.613 98.72 166.16 98.56C165.707 98.3733 165.253 98.16 164.8 97.92L152.4 91.8V88.2L169.6 96.8V100.8L152.4 109.4ZM176.984 116V113H196.184V116H176.984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaCli);
export default __webpack_public_path__ + "static/media/SolanaCLI.b729f32de12de961409865b0f9c247ce.svg";
export { ForwardRef as ReactComponent };